// extracted by mini-css-extract-plugin
export var border = "HeaderNavItem-module--border--256fd";
export var cdsAssistiveText = "HeaderNavItem-module--cds--assistive-text--32367";
export var cdsVisuallyHidden = "HeaderNavItem-module--cds--visually-hidden--386f3";
export var currentPage = "HeaderNavItem-module--currentPage--a7dc7";
export var currentPageAccordion = "HeaderNavItem-module--currentPageAccordion--2f81d";
export var hideFeedback = "HeaderNavItem-module--hide-feedback--38a39";
export var menuItem = "HeaderNavItem-module--menuItem--99a60";
export var showFeedback = "HeaderNavItem-module--show-feedback--346bf";
export var skeleton = "HeaderNavItem-module--skeleton--73831";